import {ajax} from '../modules/ajax';
import {scriptonload} from '../modules/scriptonload';
import {event} from '../modules/event';
import {Player} from '../modules/Player';
import Vote from '../modules/Vote';
import {fullscreenGalleryFunc} from  '../modules/fullscreenGallery';
import {Comments} from  '../modules/Comments';
import {YaShare2} from  '../modules/YaShare2';
import {Time} from  '../modules/Time';
import Fav from '../modules/Fav';
import Watch from '../modules/Watch';
import More from  '../modules/More';
import {TheaterMap} from  '../modules/TheaterMap';
import {ToBuy} from  '../modules/ToBuy';
import {RegAuthBtn} from  '../modules/RegAuthBtn';
import {PageForm} from '../modules/PageForm';
import {Trailer} from '../modules/Trailer';
import {AllAjax} from  '../modules/AllAjax';
import {showSubContent} from  '../modules/showSubContent';
import Rating from '../modules/Rating';
import {banners} from  '../modules/banners';


var fullscreenGallery = fullscreenGalleryFunc(window, document); /* TODO */

class SubContent {
	constructor(wrapper){
        this._createElements(wrapper);
        this._addEvents();
        this._runModules();
	}

	_createElements(wrapper){
        var self = this;
        this.wrapper = wrapper;
        this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.tabAll = this._getTabAll();
        this.frame = document.querySelector('[data-SubContent-frame]');
        this.scrollToElement = function(){
            try{
                var el = document.getElementById(self.param.scrollTo);
                if(el) return el;
                else return self.frame;
            } catch(e){
                return self.frame;
            }
        }(),
        this.ajaxPart = this._defineAjaxPart();
        this.xmlhttp = false;
        this.moduleAll = [];
        this.actions = {
            Player: function(el){return new Player(el)},
            Vote: function(el){return new Vote(el)},
            fullscreenGallery: function(el){return  fullscreenGallery(el)},
            Comments: function(el){return new Comments(el)},
            YaShare2: function(el){return new YaShare2(el)},
            Time: function(el){return new Time(el, self)},
            Fav: function(el){return new Fav(el)},
            Watch: function(el){return new Watch(el)},
            TheaterMap: function(el){
                var initMap = function(){
                        ymaps.ready(createMap);
                    },
                    createMap = function(){
                        new TheaterMap(el);
                    };
                scriptonload(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], initMap);
            },
            ToBuy: function(el){
                return new ToBuy(el)
            },
            RegAuthBtn: function(el){return new RegAuthBtn(el)},
            PageForm: function(el){return new PageForm(el)},
            uPlayer:function(el){
                var init = function(){
                    return uPlayer(el);
                }

                //
                if(!window.uPlayer) scriptonload(APP.vendors.uPlayer, init);
                else init();
            },
            Trailer: function(el, data){
                return new Trailer(el, data);
            },
            AllAjax: function(el){return new AllAjax(el)},
            More: function(el){return new More(el)},
            showSubContent: function(el){return showSubContent(el)},
            Rating: function(el){return new Rating(el)},
            banners: function(el){return banners(el)}
        };
        this.curInd;
	}

    _getTabAll(){
        var arr = {},
            all = this.wrapper.querySelectorAll('[data-SubContent-btn]'),
            l = all.length,
            i = 0;

        //
        for(i; i<l; i++){
            arr[all[i].getAttribute('data-SubContent-btn')] = all[i];
        }
        return arr;
    }

    _addEvents(){
        if(!window.history) return false;

        var self = this;

        self._checkHash();

        this._popstateOnCircuit = function(e){
            self._popstateOn.call(self, e);
        }
        event.add(window, 'popstate', self._popstateOnCircuit);

        for(var i in this.tabAll){
            var tab = this.tabAll[i];
            if(tab.className.indexOf('js-active') !== -1) {
                this.curInd = i;
                //запомнить состояние текущей вкладки Запоминаем урл
                window.history.replaceState({ind:i, pathname:window.location.pathname, search:window.location.search}, '', window.location.href);
            }

            event.add(tab, 'click', (function(i){return function(e){
                self.show.call(self,this,e,i)
            }})(i));
        }
    }

    /* check if we have hash like tab */
    _checkHash(){
        let self = this;
        let winHash = window.location.hash;
        let tabName = winHash.replace('#', '');

        if ( winHash && self._getTabAll().hasOwnProperty(tabName) ) {

            window.onload = function () {
                var h = wrapper.getBoundingClientRect().height;
                var top = self.scrollToElement.getBoundingClientRect().top - APP.vars.topPadding,
                    duration = 300,
                    offset = window.pageYOffset,
                    left = window.pageXOffset;
                self.animateObj = self.animate({
                    duration: duration,
                    timing: function(timeFraction) {
                        return timeFraction;
                    },
                    draw: function(progress) {
                        window.scrollTo(left, offset + progress * top);
                    }
                });
            };
        }
    }

    animate(options) {
        var Animate = class {
            constructor(){
                this._createElements();
                this.run();
            }
            _createElements(){
                this.req = undefined;
                this.start = undefined;
            }
            run(){
                var self = this;
                this.start = performance.now();
                this.req = requestAnimationFrame(function animate(time) {
                    // timeFraction от 0 до 1
                    var timeFraction = (time - self.start) / options.duration;
                    if (timeFraction > 1) timeFraction = 1;

                    // текущее состояние анимации
                    var progress = options.timing(timeFraction);

                    options.draw(progress);

                    if (timeFraction < 1) {
                        self.req = requestAnimationFrame(animate);
                    }
                });
            }
            stop(){
                cancelAnimationFrame(this.req);
            }
        };

        //
        return new Animate();
    }

    show(btn, e, i, targetUid){ /* здесь btn либо внешняя кнопка, либо таб, без разницы */
        var h = this.wrapper.getBoundingClientRect().height;
        var top = this.scrollToElement.getBoundingClientRect().top - APP.vars.topPadding - h + 25,
            duration = 300,
            offset = window.pageYOffset,
            left = window.pageXOffset;

        this.animateObj = this.animate({
            duration: duration,
            timing: function(timeFraction) {
                return timeFraction;
            },
            draw: function(progress) {
                window.scrollTo(left, offset + progress * top);
            }
        });

        this._switchTab(btn, e, i, targetUid);
    }

    _switchTab(btn, e, i, targetUid){
        var param = {};

        e.preventDefault();
        //if(this.curInd === i) return false;
        window.history.pushState({ind:i, pathname:btn.pathname, search:btn.search}, '', btn.pathname + btn.search);

        this._sendStat(btn.pathname + btn.search);

        param.data = this._getAjaxData(btn.search);
        param.url = this.ajaxPart + btn.pathname;

        this._prepare(i, param, targetUid);
    }

	_defineAjaxPart(){
		var part = APP.vars.isDev ?  '' : '';
		return part;
	}

	_getAjaxData(search){
        var  data = {};
        if(!search) return data;

        search = search.replace('?', '').split('&');

		for(var i= 0,j=search.length; i<j; i++){
			var item = search[i].split('=');
			data[item[0]] = item[1];
		}

		return data;
	}

    _popstateOn(e){
        var param = {};
        param.data = this._getAjaxData(e.state.search);
        param.url = this.ajaxPart + e.state.pathname;

        this._sendStat(e.state.pathname+e.state.search); /* TODO непонятно работает или нет  */

        this._prepare(e.state.ind, param);
    }

    _prepare(i, param, targetUid){

        var tab = this.tabAll[i];
        tab.className = tab.className + ' js-active';

        this.tabAll[this.curInd].className = this.tabAll[this.curInd].className.replace(' js-active', '');
        this.curInd = i;

        if(this.frame.className.indexOf('js-loading') === -1) this.frame.className = this.frame.className + ' js-loading';

        this.moduleAllRemove();

        this.getContent(param, 'POST', targetUid);
    }

    getContent(param, method, targetUid){
        var self = this;

        if(this.xmlhttp) this.xmlhttp.abort();

        this.xmlhttp = ajax({
            data:param.data,
            url:param.url,
            method:method || 'POST',
            callback: function(msg){
                self._addContent.call(self, msg, targetUid);
            }
        });
    }

    _addContent(msg, targetUid){
        this.xmlhttp = false;
        this.frame.innerHTML = msg;
        this._runModules();
        if(targetUid){
            var left = window.pageXOffset,
                top = document.getElementById(targetUid).getBoundingClientRect().top - APP.vars.topPadding;
            this.animateObj.stop();
            window.scrollBy(0, top);
        }
        this.frame.className = this.frame.className.replace(' js-loading', '');
    }

    _sendStat(page){
        try{
            // ga('set', 'page', page);
            // ga('send', 'pageview');

            gtag('config', 'UA-21667993-5', {
                'page_path': page
            });
            //if(console) console.log('GA при переключении таба обновлен - ' + page);
        } catch(e){
           // if(console) console.error('GA при переключении таба не сработал');
        }

        try{
            window.yaCounter28763351.hit(page);
            //console.log('subContent yaCounter28763351', page);
        } catch (e){}
    }

    moduleAllRemove(){
        for(var i=0,j=this.moduleAll.length; i<j; i++){
            if(this.moduleAll[i] && this.moduleAll[i].del) this.moduleAll[i].del();
            else if(this.moduleAll[i] && this.moduleAll[i].destroy) this.moduleAll[i].destroy();
        }
        this.moduleAll = [];
    }

    _runModules() {
        let subModulesAll;

        if (this.frame) {
            subModulesAll = this.frame.querySelectorAll('[data-sub-modules]');

            for (var i = 0, j = subModulesAll.length; i < j; i++) {
                var nameAll = subModulesAll[i].getAttribute('data-sub-modules').split(' ');
                for (var m = 0, n = nameAll.length; m < n; m++) {
                    if (this.actions[nameAll[m]]) {
                        this.moduleAll.push(this.actions[nameAll[m]](subModulesAll[i]));
                    }
                }
            }
        }
    }

    del(){
        event.remove(window, 'popstate', this._popstateOnCircuit);
    }
};

export {SubContent};